import { Link } from 'react-router-dom'

import { useNavbarContext } from '@/app/panel/_contexts/navbar-context'
import iconUrl from '@/assets/images/icon.png'
import logoWhiteUrl from '@/assets/images/logo-white.png'
import { cn } from '@/lib/utils'

export const Logo = () => {
  const { expanded } = useNavbarContext()

  return (
    <h1>
      <Link
        className="block h-8 rounded-md outline-none ring-0 ring-offset-0 ring-offset-white transition-opacity hover:opacity-80 focus-visible:ring-2 focus-visible:ring-gray-300 focus-visible:ring-offset-2"
        to=""
      >
        <img
          className={cn(expanded ? 'w-40' : 'w-8')}
          src={expanded ? logoWhiteUrl : iconUrl}
          alt="Logomarca Bar Fácil"
        />
      </Link>
    </h1>
  )
}
